import React from "react";
import {
    ButtonIconCancel,
    ButtonIconSave,
    convertInputFormToObject,
    SelectField,
    TextArea,
    TextField,
    useInputForm
} from "../../../../../Components/Inputs";
import {braillerInventoryItemModel} from "./braillerInventoryItemFactory";
import {BRAILLER_STATUS_LIST} from "../../braillerConstants";
import {gridConstants} from "../../../../../Components/Grid";
import {getBraillerInventoryItemId} from "./braillerInventoryUtility";

interface BraillerInventoryEditRowProps {
    canManageCatalog: boolean;
    handleSaveInventoryItem: (data: Record<string, any>, index: number) => void;
    handleCancelInventoryItem: (index: number) => void;
    index: number;
    braillerInventoryItem: Record<string, any>;
}

export const BraillerInventoryEditRow = ({
    canManageCatalog,
    handleSaveInventoryItem,
    handleCancelInventoryItem,
    index,
    braillerInventoryItem,
}: BraillerInventoryEditRowProps) => {

    const inventoryItemForm = useInputForm(braillerInventoryItemModel(braillerInventoryItem));

    const handleClickSaveInventoryItem = () => {
        const updatedItem = convertInputFormToObject(inventoryItemForm);
        handleSaveInventoryItem(updatedItem, index);
    };

    const handleClickCancelInventoryItem = () => {
        handleCancelInventoryItem(index);
    };

    const braillerInventoryItemId = getBraillerInventoryItemId(braillerInventoryItem, index);

    return (
        <tr id={braillerInventoryItemId} data-testid={braillerInventoryItemId}>
            <td>
                <TextField
                    {...inventoryItemForm.serialNumber}
                    disabled={!canManageCatalog}
                    labelClass="show-for-sr"
                    medium_columns={gridConstants.column.THREE}
                />
            </td>
            <td>
                <SelectField
                    {...inventoryItemForm.status}
                    disabled={!canManageCatalog}
                    hideLabel
                    includeDefaultOption
                    medium_columns={gridConstants.column.THREE}
                    options={BRAILLER_STATUS_LIST}
                />
            </td>
            <td>
                <TextArea
                    {...inventoryItemForm.notes}
                    disabled={!canManageCatalog}
                    label={`Notes for item ${index + 1}`}
                    medium_columns={gridConstants.column.THREE}
                />
            </td>
            <td>
                <ButtonIconSave
                    inputDescription={`save changes for item ${index + 1}`}
                    onClick={() => handleClickSaveInventoryItem()}
                />
                <ButtonIconCancel
                    inputDescription={`cancel editing for item ${index + 1}`}
                    onClick={() => handleClickCancelInventoryItem()}
                />
            </td>
        </tr>
    );
};
